import Moment from 'moment';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/styles';
import { Container, Grid, Hidden, CardContent, TextField, Typography, Button, MenuItem, Select, CardHeader } from '@material-ui/core';
import { actionAddToCartGiftCards, actionGetGiftCards, actionUpdateGiftCardDropDown, actionUpdateGiftCrdQuantity, actionUpdateGiftCardCustomAmout } from 'actions';
import * as underscore from 'underscore';
import NumberSpinner from 'components/InputControls/NumberSpinner';
import { genfunction } from '../../../../helpers';
import ErrorHandling from '../../../../components/ErrorHandling/ErrorHandling';


const { GiftCardsHeading, OrderItemsInCartError, Currency } = window['runConfig'];

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
            marginTop: theme.spacing(5)
        }
    },
    gcImg: {
        minHeight: '80px',
        maxHeight: '250px',
        minWidth: '100px',
        maxWidth: '340px'
    },
    gcImgSmall: {
        minHeight: '60px',
        maxHeight: '110px',
        minWidth: '70px',
        maxWidth: '140px'
    },
    headerText: {
        paddingBottom: 15,
        textAlign: "center"
    },
}));


const MainGiftCards = props => {

    const dispatch = useDispatch()
    const classes = useStyles();
    const [errorMsg, seterrorMsg] = React.useState('');

    useEffect(() => {
        if (giftcards.giftcards && giftcards.giftcards.length < 1) {
            actionGetGiftCards(dispatch, props.match.params.id);
        }
        else if (giftcards.giftcards && giftcards.giftcards.length > 0 && giftcards.giftcards.find(x => x.DisplayArea === parseInt(props.match.params.id)) === undefined) {
            actionGetGiftCards(dispatch, props.match.params.id);
        }
    }, []);


    const giftcards = useSelector(state => state.reducerGiftCards);
    const error = useSelector(state => state.reducerGiftCards.giftcardsError);
    const orderProducts = useSelector(state => state.reducerShopCart.orderProducts);

    const GetGroupedGiftCards = () => {
        let today = Moment(Moment().format("YYYY-MM-DD"), "YYYY-MM-DD");

        let filteredGCs = underscore.filter(giftcards.giftcards, (item) => {

            let sellStart = Moment(item.SellStart, "YYYY-MM-DD");
            let sellEnd = Moment(item.SellEnd, "YYYY-MM-DD");

            return item.DisplayArea == parseInt(props.match.params.id) && today.isBetween(sellStart, sellEnd, null, '[]');

        });

        let group = underscore
            .groupBy(filteredGCs, (giftcard) => { return giftcard.ProductImageURL; });

        return group;
    }

    const [state, setState] = React.useState([]);

    if (giftcards.giftcards && giftcards.giftcards.length > 0 && state.length < 1) {

        //giftcards.giftcards = giftcards.giftcards.filter(x => x.DisplayArea === parseInt(props.match.params.id));

        setState([...state, giftcards.giftcards]);
    }


    const fieldhandleChange = (event) => {
        if (event.target.name === "cstAmount") {
            actionUpdateGiftCardDropDown(dispatch, event.target.name, parseFloat(event.target.id));
        }
        else {
            actionUpdateGiftCardDropDown(dispatch, event.target.name, event.target.value);
        }
    }

    const SelectedGiftCardValue = (key) => {
        let val = "None";

        if (giftcards.giftcards && giftcards.giftcards.length > 0) {
            if (giftcards.giftcards.filter(x => x.ProductImageURL === key && x.isSelected).length > 0) {
                if (giftcards.giftcards.find(x => x.ProductImageURL === key && x.isSelected) !== undefined) {
                    val = giftcards.giftcards.find(x => x.ProductImageURL === key && x.isSelected).Price;
                }

            }
        }

        return val;
    }

    const SelectedGiftCardProdID = (key) => {
        let prodID = 0;

        if (giftcards.giftcards && giftcards.giftcards.length > 0) {
            if (giftcards.giftcards.filter(x => x.ProductImageURL === key && x.isSelected).length > 0) {

                if (giftcards.giftcards.find(x => x.ProductImageURL === key && x.isSelected) !== undefined) {
                    prodID = giftcards.giftcards.find(x => x.ProductImageURL === key && x.isSelected).ProductID;
                }
            }
        }

        return prodID;
    }

    const SelectedGiftCardQty = (key) => {
        let quantity = 0;

        if (giftcards.giftcards && giftcards.giftcards.length > 0) {
            if (giftcards.giftcards.filter(x => x.ProductImageURL === key && x.isSelected).length > 0) {
                quantity = giftcards.giftcards.find(x => x.ProductImageURL === key && x.isSelected).Qty;
            }
        }

        return quantity;
    }

    const CustomGiftCard = (key) => {
        let cstGiftCard = false;

        if (giftcards.giftcards && giftcards.giftcards.length > 0) {
            if (giftcards.giftcards.find(x => x.ProductImageURL === key && x.MaxPrice !== undefined) !== undefined) {
                cstGiftCard = true;
            }
        }

        return cstGiftCard;
    }

    const changeQuantityHandler = (refrence, value) => {
        actionUpdateGiftCrdQuantity(dispatch, refrence.tourProductID, value, false);
    }

    const replaceEscapeCharacters = (item) => {
        var itemValue = item.split("\\r\\n").join("<br />");
        itemValue = itemValue.split("\\").join("");
        return itemValue;
    }

    const GiftCardsTotal = () => {
        let total = 0;
        total = giftcards.giftcards ? giftcards.giftcards.filter(x => x.DisplayArea === parseInt(props.match.params.id)).map(({ TotalAmount }) => TotalAmount).reduce((sum, i) => sum + i, 0) : 0;
        return total;
    }

    const UpdateCustomAmout = (event) => {

        if (parseFloat(event.target.value) >= 0) {

            var gc = giftcards.giftcards.find(x => x.ProductID === parseInt(event.target.id));

            if (gc && parseFloat(event.target.value) > 0) {
                actionUpdateGiftCardCustomAmout(dispatch, parseInt(event.target.id), parseFloat(event.target.value), false);
            }
        }
    }

    const CustomGiftCardVal = (prodID) => {

        let val = false;

        if (giftcards.giftcards && giftcards.giftcards.length > 0) {
            if (giftcards.giftcards.find(x => x.ProductID === prodID) !== undefined) {
                val = giftcards.giftcards.find(x => x.ProductID === prodID).TotalAmount;
            }
        }
        return val;
    }

    const ValidateCustomGCs = () => {

        let valid = true;

        if (giftcards.giftcards && giftcards.giftcards.length > 0 && giftcards.giftcards.filter(x => x.CustomAmount !== undefined).length > 0) {
            giftcards.giftcards.filter(x => x.CustomAmount !== undefined).map(gc => {
                if (gc.InvalidAmount) {
                    valid = false;
                }
            });
        }

        return valid;
    }

    const AddToCard = () => {

        if (orderProducts && orderProducts.length > 0) {
            seterrorMsg(OrderItemsInCartError);
            return;
        }

        if (giftcards.giftcards && giftcards.giftcards.find(x => x.Qty > 0) !== undefined) {

            if (!ValidateCustomGCs()) {
                seterrorMsg('Please enter valid amount.');
                return;
            }

            actionAddToCartGiftCards(dispatch, parseInt(props.match.params.id));

            props.history.push({
                pathname: '/checkout'
            })
        }
        else {
            seterrorMsg('Please select any giftcard');
        }
    }

    const errorcancelhandle = () => {
        seterrorMsg('');
    }

    return (
        <Container className={classes.root}>
            <ErrorHandling msg={errorMsg && errorMsg.length > 0 ? errorMsg : ''}
                open={errorMsg && errorMsg.length > 0 ? true : false} handleclose={errorcancelhandle} />
            <Typography variant="h1" component="h1" color="primary" className={classes.headerText}>{GiftCardsHeading}</Typography>
            <Grid container justify="center" spacing={1} style={{ marginTop: 20 }}>
                <Grid container item xs={12} md={7}>

                    {giftcards.giftcards && underscore.map(GetGroupedGiftCards(), (items, key) => {
                        return (
                            <>
                                <Grid item xs={5} style={{ marginTop: 20 }} >
                                    {items.DisplayArea === parseInt(props.match.params.id) && items.length > 1 || !CustomGiftCard(key) ?
                                        <Grid align="center" xs={12}>
                                            <Hidden smDown>
                                                < img src={genfunction.replaceEscapeCharacters(key)} className={classes.gcImg} />
                                            </Hidden>

                                            <Hidden xsDown mdUp>
                                                < img src={genfunction.replaceEscapeCharacters(key)} className={classes.gcImgSmall} />
                                            </Hidden>

                                            <Hidden smUp>
                                                < img src={genfunction.replaceEscapeCharacters(key)} className={classes.gcImgSmall} />
                                            </Hidden>

                                        </Grid>
                                        :
                                        <Grid align="center" xs={12} >
                                            <Hidden smDown>
                                                < img src={genfunction.replaceEscapeCharacters(key)} className={classes.gcImg} />
                                            </Hidden>

                                            <Hidden xsDown mdUp>
                                                < img src={genfunction.replaceEscapeCharacters(key)} className={classes.gcImgSmall} />
                                            </Hidden>

                                            <Hidden smUp>
                                                < img src={genfunction.replaceEscapeCharacters(key)} className={classes.gcImgSmall} />
                                            </Hidden>

                                        </Grid>
                                    }
                                </Grid>
                                <Grid xs={7} align="right" style={{ marginTop: 20 }} >

                                    {items.length > 1 ?
                                        <Grid style={{ marginTop: 10 }}><Select
                                            labelId="Gift Cards"
                                            id={key}
                                            name={key}
                                            value={SelectedGiftCardValue(key)}
                                            onChange={fieldhandleChange}
                                            style={{ minWidth: 200 }}
                                        >
                                            <MenuItem value="None">
                                                <em>Select Amount</em>
                                            </MenuItem>
                                            {items.map((item, i) =>
                                                (<MenuItem key={i} id={item.ProductID} prodID={item.ProductID} value={item.Price}>{item.ProductName}</MenuItem>))}
                                        </Select>
                                            <Grid align="right" style={{ marginTop: 10 }} >
                                                <NumberSpinner
                                                    refrence={{ eventId: SelectedGiftCardValue(key), tourProductID: SelectedGiftCardProdID(key) }}
                                                    value={parseInt(SelectedGiftCardQty(key))}
                                                    minValue={0} maxValue={999} steps={1}
                                                    changeHandler={(refrence, value) => { changeQuantityHandler(refrence, value) }}
                                                ></NumberSpinner>
                                            </Grid>
                                        </Grid>
                                        :
                                        <>
                                            {items[0].hasOwnProperty("MaxPrice") ?
                                                <Grid style={{ marginTop: 30 }} >
                                                    <Grid style={{
                                                        display: 'flex',
                                                        flex: '1',
                                                        'justify-content': 'flex-end'
                                                    }}>
                                                        <Typography variant='h5' style={{ marginTop: 20, padding: "0px 10px 0px 0px" }}> {Currency}</Typography>

                                                        <TextField
                                                            id={items[0].ProductID}
                                                            name="cstAmount"
                                                            variant="outlined"
                                                            type="number"
                                                            CustomAmount
                                                            value={CustomGiftCardVal(items[0].ProductID)}
                                                            error={items[0].hasOwnProperty('InvalidAmount') ? items[0].InvalidAmount : false}
                                                            onChange={UpdateCustomAmout}
                                                            inputProps={{
                                                                pattern: "[0-9]*",
                                                                min: 0, style: { textAlign: 'right' }
                                                            }}
                                                        />
                                                    </Grid>

                                                    <Typography>(Min {Currency}{items[0].Price}, Max {Currency}{items[0].MaxPrice})</Typography>
                                                </Grid>
                                                :
                                                <Grid style={{ marginTop: 10 }} align="right" >
                                                    <Typography variant="subtitle1" gutterBottom> {items[0].ProductName}</Typography>
                                                    <NumberSpinner
                                                        refrence={{ eventId: items[0].Price, tourProductID: items[0].ProductID }}
                                                        value={parseInt(items[0].Qty)}
                                                        minValue={0} maxValue={999} steps={1}
                                                        changeHandler={(refrence, value) => { changeQuantityHandler(refrence, value) }}
                                                    ></NumberSpinner>
                                                </Grid>
                                            }
                                        </>
                                    }

                                </Grid>
                            </>
                        )
                    })}

                    <Grid xs={12} align="right" >
                        <Grid xs={7} align="right" style={{ marginTop: 50 }}>
                            <Typography variant="h4" component="h4" >
                                Total = {genfunction.ccyFormat(GiftCardsTotal())}
                            </Typography>

                        </Grid>
                    </Grid>
                    <Grid xs={12} align="right" >
                        <Grid xs={7} align="right">
                            <Button style={{ marginTop: 30 }}
                                color="primary" variant="contained"
                                onClick={() => AddToCard()}
                            >Add to cart</Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

        </Container >
    );
};

export default MainGiftCards;
